import { useSelector } from 'react-redux';
import AddList from '../../../../../../components/Dialog/AddList';
import AddTaxInvoiceDetails from '../../../../user-dashboard/settings/my-profile/AddTaxInvoiceDetails';
import TaxInvoiceInfo from './TaxInvoiceInfo';
import useTaxInvoiceDetailManage from '../hooks/useTaxInvoiceDetailManage';

function TaxInvoiceDetailManage() {
    const { user } = useSelector((state) => state.auth);
    const { isOpenTaxInvoiceModal, setIsOpenTaxInvoiceModal } = useTaxInvoiceDetailManage();

    return (
        <div className="user-profile-main-container">
            {!isOpenTaxInvoiceModal && !user?.verification?.pan_number && (
                <AddList
                    heading="No tax invoice details added!"
                    desc1="No tax invoice details have been added yet."
                    desc2=""
                    buttonText="Add Tax Invoice Details"
                    onClick={() => setIsOpenTaxInvoiceModal(true)}
                />
            )}

            {user?.verification?.pan_number && <TaxInvoiceInfo />}

            {isOpenTaxInvoiceModal && (
                <AddTaxInvoiceDetails onClose={() => setIsOpenTaxInvoiceModal(false)} />
            )}
        </div>
    );
}

export default TaxInvoiceDetailManage;
